import { apiConstants } from "../../../../utils/apiConstants";
import { apiTypes } from "../../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../../utils/getAxiosCancelToken";
import apiRequestType from "../../../apiRequestType";

let cancelToken;

const getFilterClassVisualReport = (data) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.POST,
    apiConstants.REPORT.GRAPHICAL_REPORT.FILTER_CLASS_VISUAL_REPORT,
    data,
    cancelToken
  );
};
export default getFilterClassVisualReport;
